module.exports = function() {
  return new Worker(__webpack_public_path__ + "065e47ac07e693a716dc.worker.js");
};